// extracted by mini-css-extract-plugin
export default {"TextHeader":"hzP0bc8j"};